export default {"src":"/_next/static/media/time.b19b1e44.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};